import type { i18n as I18n } from 'i18next';

/**
 * Names a row's overflow-menu button after the row it belongs to.
 *
 * A screen reader can list every button on the page on its own, away from the
 * row each one sits in. Twenty identical "More options" entries are useless
 * there, so the name has to carry its subject.
 *
 * Falls back to the bare label when the row has no name to show, rather than
 * announcing "More options for" with nothing after it.
 */
export const getMoreOptionsLabel = (i18next: I18n, name?: string) =>
    name
        ? i18next.t('menu.more_options_for', { name })
        : i18next.t('menu.more_options');
